var exports = {
  "Wi": "actionMenu__2v-6qm",
  "BN": "mobileButton__J513wB",
  "AS": "item__rruuKe",
  "Kk": "icon__lClXIt",
  "R_": "heading__f5SDdZ",
};

module.exports = exports;
